import { useState, useEffect } from 'react';
import { screens } from '@/utils/styles';

type BreakpointKey = keyof typeof screens;

const getBreakpoint = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  let breakpoint: BreakpointKey | null = null;

  const sortedBreakpoints = Object.entries(screens).sort(
    (a, b) => parseInt(b[1]) - parseInt(a[1]),
  );

  for (const [key, value] of sortedBreakpoints) {
    if (matchMedia(`(min-width: ${value})`).matches) {
      breakpoint = key as BreakpointKey;
      break;
    }
  }

  return breakpoint;
};

const useBreakpoint = () => {
  const [currentBreakpoint, setCurrentBreakpoint] =
    useState<BreakpointKey | null>(getBreakpoint());

  const isMobile = currentBreakpoint === 'sm';
  const isTablet = currentBreakpoint === 'md';
  const isDesktop =
    currentBreakpoint === 'lg' ||
    currentBreakpoint === 'xl' ||
    currentBreakpoint === '2xl';

  useEffect(() => {
    const handleResize = () => {
      setCurrentBreakpoint(getBreakpoint());
    };

    addEventListener('resize', handleResize);

    return () => {
      removeEventListener('resize', handleResize);
    };
  }, []);

  return { isMobile, isTablet, isDesktop };
};

export default useBreakpoint;
